import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { MultipleFlavorsSelector, PopperProvider, useConfig } from "@jti/ui";
import { getBundleConfig, getBundleOptions, getInitialSticks, getMultipleFlavorsStick, getQtyForMultipack, setCurrentConfig, } from "../../../../aem-components/product-details/utils";
import { isInStock } from "../../../../utils/app-related/isInStock";
import ProductBundlesBlock from "./ProductBundlesBlock";
import ProductBundlesStickBlock from "./ProductBundlesStickBlock";
import "./ProductBundles.scss";
const getElement = (element) => {
    return {
        product: element,
        data: {
            value: element.id,
            quantity: 1,
            isInStock: element.isInStock ?? true,
        },
    };
};
const getCurrentModel = (blocks) => blocks.reduce((prev, block) => {
    const productObject = block.options.find((option) => option.isDefault);
    if (!productObject) {
        return prev;
    }
    return {
        ...prev,
        [block.optionId]: getElement(productObject),
    };
}, {});
const ProductBundles = ({ config, isStockLoading, showValidation, stockStatusElements, multipacksQuantities, onSet, setLastSelectedElement, }) => {
    const { displayOutOfStockBundleOptions, drawerFlavourSelectorForBundles = false } = useConfig();
    const [selectedElements, setSelectedElements] = useState({});
    const { blocks, sticks } = getBundleConfig(config);
    const onChange = (optionId) => (data) => {
        if (!data?.value) {
            return;
        }
        const newSelectedElement = {
            [optionId]: getElement({
                ...data.additionalData,
                isInStock: data.isInStock,
            }),
        };
        const lastSelectedElement = {
            optionId,
            productId: newSelectedElement[optionId].product.id,
            type: "select",
        };
        setLastSelectedElement(lastSelectedElement);
        setSelectedElements({
            ...selectedElements,
            ...newSelectedElement,
        });
    };
    const onChangeStick = (optionId, item) => (data) => {
        const newSelectedElement = {
            [optionId]: {
                data,
                product: item,
            },
        };
        const lastSelectedElement = {
            optionId,
            type: "multi",
            quantities: data.quantities,
        };
        setLastSelectedElement(lastSelectedElement);
        setSelectedElements({
            ...selectedElements,
            ...newSelectedElement,
        });
    };
    const handleStickSelection = useCallback((optionId, item) => (data) => {
        const quantities = Object.entries(data).map(([selection_id, qty]) => ({
            selection_id,
            qty,
        }));
        const newSelectedElement = {
            [optionId]: {
                data: {
                    value: Object.keys(data),
                    quantities: quantities,
                },
                product: item,
            },
        };
        const lastSelectedElement = {
            optionId,
            type: "multi",
            quantities: quantities,
        };
        setLastSelectedElement(lastSelectedElement);
        setSelectedElements({
            ...selectedElements,
            ...newSelectedElement,
        });
    }, [selectedElements, setLastSelectedElement]);
    useEffect(() => {
        setSelectedElements((prev) => ({ ...prev, ...getCurrentModel(blocks) }));
    }, [multipacksQuantities]);
    useEffect(() => {
        onSet(setCurrentConfig(selectedElements));
    }, [selectedElements]);
    const isOutOfStockVisible = displayOutOfStockBundleOptions ?? false;
    const getInStockBundleOptions = (options) => {
        if (!Array.isArray(options)) {
            return [];
        }
        return options.filter((option) => isInStock(stockStatusElements[option?.id]));
    };
    const getItemsOptionsList = (item) => 
    // adding filtering for out of stock bundle options due to changes in Magento API - options now include out of stock items - similar ot allOptions
    isOutOfStockVisible ? item.allOptions : getInStockBundleOptions(item.options);
    return (_jsxs(PopperProvider, { children: [blocks.map((item) => (_jsx(ProductBundlesBlock, { isLoading: isStockLoading, title: item.title, currentProduct: selectedElements[item.optionId]?.product || null, showValidation: showValidation, onChange: onChange(item.optionId), options: getBundleOptions(getItemsOptionsList(item), stockStatusElements), stockStatusElements: stockStatusElements }, item.title))), sticks.map((item) => {
                const numberOfSticks = getQtyForMultipack(multipacksQuantities, item.optionId);
                const options = getBundleOptions(getItemsOptionsList(item), stockStatusElements);
                return drawerFlavourSelectorForBundles === true ? (_jsx(MultipleFlavorsSelector, { limit: numberOfSticks, shouldValidate: showValidation, items: options.map(getMultipleFlavorsStick), stockStatusElements: stockStatusElements, onChange: handleStickSelection(item.optionId, item), defaultFlavorsSelection: getInitialSticks(options, numberOfSticks, stockStatusElements) }, item.sku)) : (_jsx(ProductBundlesStickBlock, { isLoading: isStockLoading, title: item.title, sticksCount: numberOfSticks, showValidation: showValidation, options: options, stockStatusElements: stockStatusElements, onChange: onChangeStick(item.optionId, item) }, item.sku));
            })] }));
};
export default ProductBundles;
//# sourceMappingURL=ProductBundles.js.map